import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.23 10.999A9.23 9.23 0 0 0 11 1.769a.75.75 0 0 0-.75.75V11c0 .414.336.75.75.75h8.48a.75.75 0 0 0 .75-.75m-1.538-.75H11.75V3.306a7.73 7.73 0 0 1 6.942 6.943m-16.921.75c0-4.32 2.97-7.949 6.979-8.953v1.556a7.73 7.73 0 1 0 9.646 9.646h1.557c-1.005 4.01-4.632 6.98-8.953 6.98a9.23 9.23 0 0 1-9.23-9.229",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }